import classNames from 'classnames'

import { ICreateItemButton } from '../../models/ICreateItemButton'

import styles from './CreateItem.module.scss'

export const CreateItem = ({ onClick, className }: ICreateItemButton) => {
  return (
    <div
      tabIndex={1}
      className={classNames(styles.createButton, className)}
      data-testid="createItemButton"
      onClick={onClick}
    >
      Create item
    </div>
  )
}
